import * as React from "react"
import styles from "./MainDropdown.module.scss"

const MainDropdown = (props) => {
  const [isOpenDropdown, setIsOpenDropdown] = React.useState(false)

  const handleTriggerOpenDropdown = () => {
    setIsOpenDropdown(!isOpenDropdown)
  }

  return (
    <div onClick={handleTriggerOpenDropdown} onBlur={() => setIsOpenDropdown(false)} tabIndex={-1}
         className={styles.mainDropdown}>
      <div className={[styles.customSelect, (isOpenDropdown ? styles.open : null)].join(' ')}>
        <div className={styles.customSelect__trigger}><span>{props.value || props.placeholder}</span>
          <div className={[styles.arrow, (isOpenDropdown ? styles.open : null)].join(' ')}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.8332 7.08334L9.99984 12.9167L4.1665 7.08334" stroke="#0A195C" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div className={styles.customOptions}>
          {
            (props.options?.length > 0) && props.options.map(item => (
              <span
                onClick={() => props.onChange(item)}
                className={[
                  styles.customOption,
                  (props.disabled ? styles.disabled : ''),
                ].join(' ')}
                data-value={item}
              >
                            {item}
                          </span>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export default MainDropdown